// Initialize stuff
import './utilities/initalizeSdks'
import 'functions/routes/appRoutes'
import 'functions/routes/queryNames'
import 'kat/lib/utilities/polyfills'
import './state/getters/getBackLocation'

import * as React from 'react'
import * as ReactDOM from 'react-dom'

import { Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import { createBrowserHistory } from 'history'
import { Provider } from 'react-redux'
// import { createWindowClickAction } from 'actionCreators/createWindowClickAction'
import { createAppStore } from 'kat/lib/state/createAppStore'
import { rootReducer } from 'state/reducers/rootReducer'
import { flows } from 'flows/flows'
import { reduxLogger } from 'state/reduxLogger'
import { envConfig } from './functions/envConfig/envConfig'
import { WindowResizeAction } from 'kat/lib/actionCreators/types/WindowResizeAction'
import { getViewPortWidth } from 'kat/lib/utilities/getViewPortWidth'
import { getViewPortHeight } from 'kat/lib/utilities/getViewPortHeight'
import { LocationWatcher } from 'kat/lib/com/watcher/LocationWatcher'
import { appRoutes } from 'functions/routes/appRoutes'
import { queryNames } from 'functions/routes/queryNames'
import { IndexRouter } from 'com/router/IndexRouter'

const rootEl = document.getElementById('root') as HTMLElement
const history = createBrowserHistory()

const store = createAppStore({
  rootReducer: rootReducer as any,
  flows,
  history,
  reduxLogger,
  enableLogger:
    envConfig.environment === 'local' ||
    envConfig.environment === 'development',
})

const dispatchWindowResize = () => {
  var width = getViewPortWidth()
  var height = getViewPortHeight()

  store.dispatch<WindowResizeAction>({
    type: 'WINDOW_RESIZE',
    description: 'index',
    values: {
      width,
      height,
    },
  })
}

window.onresize = dispatchWindowResize
window.storeDispatch = store.dispatch

const providerApp = (
  <Provider store={store}>
    <LocationWatcher
      history={history}
      appRoutes={appRoutes}
      queryNames={queryNames}
    />
    <Router location={history.location} navigator={history}>
      <IndexRouter />
    </Router>
  </Provider>
)

ReactDOM.render(providerApp, rootEl)

if (false) {
  // Dont need offline mode
  serviceWorker.register()
} else {
  serviceWorker.unregister()
}
